














































































import Level from '@/domain/assessment/entity/assignment/level';
import AssessmentService from '@/domain/assessment/service/assessment.service';
import AssignmentService from '@/domain/drd/service/assignment.service';
import { VbSnackbarService } from 'bag-of-holding-library';
import { Vue, Component, Prop } from 'vue-property-decorator';
import AssignmentSingleFilter from '@/shared/filters/assignment/assignment-single-filter.component.vue';
import LabelSlot from '@/shared/slots/label-slot.component.vue';

@Component({
  components: {
    AssignmentSingleFilter,
    LabelSlot,
  },
})
class NewAssessmentModalComponent extends Vue {
  @Prop({
    type: Boolean,
    required: true,
  }) show!: boolean;

  assignmentIdSelected: string | null = null;

  levelIdSelected: string | null = null;

  loadingStartSimulation: boolean = false;

  loadingLevels: boolean = false;

  levels: Level[] = [];

  handleAssignmentSelected(event: string) {
    this.assignmentIdSelected = event;
    this.getAllLevels();
  }

  getAllLevels() {
    if (!this.assignmentIdSelected) return;
    this.loadingLevels = true;
    AssignmentService.getLevelsByAssignmentId(this.assignmentIdSelected)
      .then(response => this.levels = response)
      .finally(() => this.loadingLevels = false);
  }

  getSimulationForm() {
    if (this.assignmentIdSelected && this.levelIdSelected) {
      this.loadingStartSimulation = true;
      AssessmentService.getSimulationForm(
        this.assignmentIdSelected,
        this.levelIdSelected,
      ).then((response) => {
        this.$emit('simulationCreated', response);
      })
        .catch((error) => {
          VbSnackbarService.handleHttpError(error);
        })
        .finally(() => this.loadingStartSimulation = false);
    }
  }
}

export default NewAssessmentModalComponent;
